var e = "rsd_",
  t = function (e, t, r) {
    return Array.from({
      length: (t - e) / r + 1
    }, function (t, n) {
      return e + n * r;
    });
  },
  r = function (e, t) {
    for (var r = new Date("".concat(e, "/").concat(t, "/01")), n = []; r.getMonth() + 1 === t;) n.push(new Date(r).getDate()), r.setDate(r.getDate() + 1);
    return n;
  },
  n = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  },
  a = function (e, r, n) {
    var a = t(r ? r.getFullYear() : new Date().getFullYear(), e ? e.getFullYear() : 1900, -1);
    return n && (a = a.reverse()), a.map(function (e, t) {
      return {
        value: e,
        label: "".concat(e)
      };
    });
  },
  u = function (e, r, a, u) {
    void 0 === a && (a = -1), void 0 === u && (u = n);
    var l = t(1, 12, 1);
    if (r && -1 !== a && a === r.getFullYear()) {
      var o = r.getMonth() + 1;
      l = l.slice(0, o);
    }
    if (e && -1 !== a && a === e.getFullYear()) {
      var c = e.getMonth() + 1;
      l = l.slice(c - 1, l.length);
    }
    return l.map(function (e, t) {
      return {
        value: e,
        label: u[e]
      };
    });
  },
  l = function (e, n, a, u) {
    void 0 === a && (a = -1), void 0 === u && (u = -1);
    var l = [];
    if (-1 === a) return (l = t(1, 31, 1)).map(function (e, t) {
      return {
        value: e,
        label: "".concat(e)
      };
    });
    if (l = r(-1 === u ? 1900 : u, a), n && u === n.getFullYear() && a === n.getMonth() + 1) {
      var o = n.getDate();
      l = l.slice(0, o);
    }
    if (e && u === e.getFullYear() && a === e.getMonth() + 1) {
      var c = e.getDate();
      l = l.slice(c - 1, l.length);
    }
    return l.map(function (e, t) {
      return {
        value: e,
        label: "".concat(e)
      };
    });
  };
export { e as classPrefix, n as englishMonths, r as getAllDaysInMonth, l as getDaysObject, u as getMonthsObject, a as getYearsObject, t as range };